export const REPORT_ITEM_TYPE_SIGNAL_STATISCTICS = 'signal_statistics'
export const REPORT_ITEM_TYPE_SIGNAL_PLOT = 'plot'
export const REPORT_ITEM_TYPE_DTC_ANALYSIS = 'dtc'
export const REPORT_ITEM_TYPE_GPS_TRACKING = 'gps'
export const REPORT_ITEM_TYPE_HISTOGRAM = 'histogram'

export const LOCAL_REPORT_ITEM_TYPE_CHART = 'CHART'
export const LOCAL_REPORT_ITEM_TYPE_MP_SCALAR = 'MP_SCALAR'
export const LOCAL_REPORT_ITEM_TYPE_TABLE = 'TABLE'
export const LOCAL_REPORT_ITEM_TYPE_MAP = 'MAP'
export const LOCAL_REPORT_ITEM_TYPE_JSON = 'JSON'
export const LOCAL_REPORT_ITEM_TYPE_IMAGE = 'IMAGE'
